@if (is_offline === false) {
  <h1>Заходили в систему</h1>
}
@if (is_offline === true) {
  <h1>Никогда не заходили в систему</h1>
}
@if (is_offline === null) {
  <h1>Все сотрудники</h1>
}
<app-simple-table>
  <app-simple-table-th>№ п/п</app-simple-table-th>
  <app-simple-table-th>ФИО сотрудника</app-simple-table-th>
  <app-simple-table-th>Телефон сотрудника</app-simple-table-th>
  <app-simple-table-th>E-mail сотрудника</app-simple-table-th>
  <!-- // -->
  @for (row of staff; track row; let i = $index) {
    <app-simple-table-tr>
      <td>{{i+1}}</td>
      <td>{{row['physic_fio']}}</td>
      <td>{{row['physic_phone']}}</td>
      <td>{{row['physic_email']}}</td>
    </app-simple-table-tr>
  }
</app-simple-table>
